import { FC, KeyboardEvent, useEffect, useRef } from 'react';
import type { AutoResizingTextareaProps } from './Textarea.types';

import styles from './Textarea.module.css';

export const Textarea: FC<AutoResizingTextareaProps> = ({ value, onChange, onEnterPress, placeholder }) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
        }
    }, []);

    useEffect(() => {
        if (textareaRef.current) {
            if (value.length === 0 || textareaRef.current.scrollHeight < 48) {
                textareaRef.current.style.height = '48px';
            } else {
                textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
            }
        }
    }, [value]);

    const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault();

            if (onEnterPress && !event.shiftKey) {
                onEnterPress();
            }
        }
    };

    return (
        <textarea
            className={styles.resizeTextarea}
            ref={textareaRef}
            value={value}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            rows={1}
        />
    );
};